import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NotificationStatus } from 'src/app/library/enums/notifications/notifications.enum';
import { UserAuthService } from 'src/app/modules/auth/services/user.service';
import { INotificationResponseModel } from 'src/app/modules/notifications/interfaces/notification-response-model';

@Component({
    selector: 'app-notification-details',
    templateUrl: './notification-details.component.html',
    styleUrls: ['./notification-details.component.scss']
})
export class NotificationDetailsComponent implements OnInit {
    @Input() notification: INotificationResponseModel;
    @Output() toggleReadNotificationEvent =
        new EventEmitter<INotificationResponseModel>();
    @Output() notificationViewEvent =
        new EventEmitter<INotificationResponseModel>();

    public notificationStatuses = NotificationStatus;

    constructor(public userAuthService: UserAuthService) {}

    ngOnInit() {}

    public onViewNotification(event: Event): void {
        event.preventDefault();
        event.stopPropagation();
        this.notificationViewEvent.emit(this.notification);
    }

    public toggleReadNotification(event: Event): void {
        event.preventDefault();
        event.stopPropagation();
        this.toggleReadNotificationEvent.emit(this.notification);
    }
}
